
import { getAuthProps } from "../../lib/authenticationLibrary";
import { AppId } from "./appSettings";


export function getAuditContext() {
    try {
        const defaultAdminUserId = 0;
        const defaultAppId = 0;

        const cookie = getAuthProps() || {};

        let adminUserId = Number(cookie.adminUserId);
        if (isNaN(adminUserId) || adminUserId <= 0) {
            adminUserId = defaultAdminUserId;
        }

        let appId = Number(AppId);
        if (isNaN(appId) || appId <= 0) {
            appId = defaultAppId;
        }

        return { adminUserId, appId };
    } catch (error) {
        console.error("Audit Context Error:", error);
        return { adminUserId: 0, appId: 0 };
    }
}